module.exports = __webpack_public_path__ + "img/39.04b4d3a8.svg";